import styled from 'styled-components';
import { ColorIconName, Icon, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { DiffMode } from '@ardoq/api-types';
import { VIEW_LEGEND_ITEM_BOTTOM_MARGIN } from './consts';
import { s8 } from '@ardoq/design-tokens';
import { VisualDiffLegendLabels } from './types';

const ViewLegendItemLabel = styled.span`
  margin-left: ${s8};
  user-select: text;
  max-width: 252px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Legend = styled.div<{ $singleColumn?: boolean }>`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  width: ${({ $singleColumn }) => ($singleColumn ? '100%' : '50%')};
  margin-bottom: ${VIEW_LEGEND_ITEM_BOTTOM_MARGIN};
`;

type VisualDiffLegendsProps = {
  activeDiffMode: DiffMode;
  labels?: VisualDiffLegendLabels;
};
const VisualDiffLegends = ({
  activeDiffMode,
  labels,
}: VisualDiffLegendsProps) => {
  const {
    added = 'added',
    changed = 'changed',
    removed = 'removed',
    unchanged = 'unchanged',
    componentPresentInScenario = 'Component present in scenario',
    componentPresentInMainline = 'Component present in mainline',
  } = labels ?? {};

  if (activeDiffMode === DiffMode.DIFF) {
    return (
      <FlexBox flexWrap>
        <Legend>
          <Icon
            iconName={ColorIconName.VISUAL_DIFF_ADDED}
            iconSize={IconSize.SMALL}
          />
          <ViewLegendItemLabel>{added}</ViewLegendItemLabel>
        </Legend>
        <Legend>
          <Icon
            iconName={ColorIconName.VISUAL_DIFF_CHANGED}
            iconSize={IconSize.SMALL}
          />
          <ViewLegendItemLabel>{changed}</ViewLegendItemLabel>
        </Legend>
        <Legend>
          <Icon
            iconName={ColorIconName.VISUAL_DIFF_REMOVED}
            iconSize={IconSize.SMALL}
          />
          <ViewLegendItemLabel>{removed}</ViewLegendItemLabel>
        </Legend>
        <Legend>
          <Icon
            iconName={ColorIconName.VISUAL_DIFF_UNCHANGED}
            iconSize={IconSize.SMALL}
          />
          <ViewLegendItemLabel>{unchanged}</ViewLegendItemLabel>
        </Legend>
      </FlexBox>
    );
  }

  return (
    <FlexBox flexWrap>
      <Legend $singleColumn={true}>
        <svg viewBox="0 0 56 56" width="28px">
          <circle
            cx="28"
            cy="28"
            r="26"
            fill="none"
            stroke="black"
            strokeWidth="2"
            strokeDasharray="2 4"
          />
        </svg>
        <span>
          {activeDiffMode === DiffMode.MAIN
            ? componentPresentInScenario
            : componentPresentInMainline}
        </span>
      </Legend>
    </FlexBox>
  );
};

export { VisualDiffLegends };
